import { useMemo } from 'react';
import classNames from 'classnames';

import { DoughnutChart } from '@Components/Base';
import { RequestsStatusesResponse } from '@Types/api/dashboardWidgets/RequestsStatuses';
import { Col, Row } from 'antd';
// import ProjectMock from '@Images/mocks/projects-mock.png';

import commonStyle from '../../common-desktop-styles.module.css';
import styles from './component-styles.module.css';
import { ApprovalStatusItem } from '../components';

interface ReportsDesktopProps {
  requestsStatuses: RequestsStatusesResponse['requestsByStatuses'];
  handleViewAll: () => void;
}

const ReportsDesktop: React.FC<ReportsDesktopProps> = ({
  requestsStatuses,
  handleViewAll,
}) => {
  const dataChart = useMemo(() => {
    return [
      requestsStatuses?.PENDING,
      requestsStatuses?.OPEN,
      requestsStatuses?.APPROVED,
      requestsStatuses?.REJECTED,
    ];
  }, [requestsStatuses]);

  return (
    <div
      className={classNames(
        styles.reportsSection,
        'trojan-glassphormism-box trojan-glassphormism-box-shadow'
      )}
    >
      <div className={commonStyle.header}>
        <div className={commonStyle.caption}>Reports</div>
        <div className={commonStyle.link} onClick={handleViewAll}>
          View All
        </div>
      </div>
      <Row className={commonStyle.row} gutter={24}>
        {/* <Col span={12}>
          <div className={styles.projects}>
            <img
              className={commonStyle.mockImage}
              src={ProjectMock}
              alt="Project information"
            />
          </div>
        </Col> */}
        <Col span={24}>
          <div className={styles.approvalsStatus}>
            <div className={styles.captionHeader}>
              <div className={styles.captionWidget}>Approvals Status</div>
              <div>Today</div>
            </div>
            <div className={styles.wrapper}>
              <div className={styles.chartWrapper}>
                <DoughnutChart statusesData={dataChart} />
              </div>
              <div className={styles.statuses}>
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.PENDING}
                  statusText="PENDING"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.OPEN}
                  statusText="OPEN"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.APPROVED}
                  statusText="APPROVED"
                />
                <ApprovalStatusItem
                  requestsValueStatuses={requestsStatuses?.REJECTED}
                  statusText="DECLINED"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ReportsDesktop;
